import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Button, Pagination, PaginationItem, Input, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { BASE_URL } from "../../../constants";

function Users() {
	const navigate = useNavigate();
	const [users, setUsers] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(5);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");

	useEffect(() => {
		fetchData();
	}, [currentPage, perPage, searchQuery]);

	const toggleDropdown = () => {
		setDropdownOpen(prevState => !prevState);
	};

	const handleSearchInputChange = (event) => {
		setSearchQuery(event.target.value);
	};

	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/user/super-admin/list?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					console.log(data, 'data');
					if (data.status) {
						setUsers([...data.result.data]);
						setTotalPages(data.result.meta_info.total_pages);
					} else {
						console.error("Error: Unable to fetch users data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};


	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};

	return (
		<div className="content">
			<h4>Users</h4>
			<Card>
				<CardBody>

					<Row className="my-3">
						<Col xs="12" className="text-end">
							<Input
								type="text"
								placeholder="Search by email"
								value={searchQuery}
								onChange={handleSearchInputChange}
								style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
							/>
							{/* <Button color="primary" onClick={handleSearch}>Search</Button> */}
						</Col>
					</Row>


					<Table responsive>
						<thead>
							<tr>
								<th>#</th>
								<th>Type</th>
								<th>First Name</th>
								<th>Last Name</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Status</th>
								<th>Package</th>
								<th>Purchase From</th>
								<th>Created At</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{users.length === 0 ? (
								<tr>
									<td colSpan="12" className="text-center">
										No users available.
									</td>
								</tr>
							) : null }

							{users.map((user, index) => (
								<tr key={index}>
									<td>{(currentPage - 1) * perPage + index + 1}</td>
									<td>{user.type}</td>
									<td>{user.first_name}</td>
									<td>{user.last_name}</td>
									<td>{user.email}</td>
									<td>{user.phone}</td>
									<td>{user.status}</td>
									<td>{user.package_title}</td>
									<td>{user.subscription_type}</td>
									<td>{user.created_at}</td>
									<td>
									<Button color="secondary" onClick={() => navigate(`/user/edit/${user.id}`)}>View</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>


				</CardBody>
				<Row>
					<Col xs="4">

						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>

					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>

							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink

										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>

								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}

								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink

													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink

										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>
						</div>
					</Col>
				</Row>

			</Card>

		</div>
	);
}

export default Users;
